import { createContext, useContext, useState, ReactNode } from 'react'
import { Box } from '@mui/material'
import { layoutStyles as styles } from 'src/components/Layout/LayoutStyles'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import InfoBar from 'src/components/shared/ui/InfoBar/InfoBar'

const SUCCESS_STATE = {
  message: '',
  type: AlertType.SUCCESS
}

const INFO_STATE = {
  message: '',
  type: AlertType.SUCCESS
}

const ERROR_STATE = {
  message: '',
  type: AlertType.ERROR
}

const WARNING_STATE = {
  message: '',
  type: AlertType.WARNING
}

type SnackbarInfo = {
  message: string
  type: AlertType
}

type SnackbarReturnedObject = {
  setSnackbarInfo: (info: SnackbarInfo) => void
  setSuccessMessage: (message: string) => void
  setInfoMessage: (message: string) => void
  setWarningMessage: (message: string) => void
  setErrorMessage: (message: string) => void
}

export const SnackbarContext = createContext({} as SnackbarReturnedObject)

export const SnackbarContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [snackbarInfo, setSnackbarInfo] = useState(SUCCESS_STATE)

  function resetSnackbar() {
    setSnackbarInfo(SUCCESS_STATE)
  }

  function setSuccessMessage(message: string) {
    setSnackbarInfo({
      ...SUCCESS_STATE,
      message
    })
  }

  function setInfoMessage(message: string) {
    setSnackbarInfo({
      ...INFO_STATE,
      message
    })
  }

  function setWarningMessage(message: string) {
    setSnackbarInfo({
      ...WARNING_STATE,
      message
    })
  }

  function setErrorMessage(message: string) {
    setSnackbarInfo({
      ...ERROR_STATE,
      message
    })
  }

  return (
    <SnackbarContext.Provider
      value={{
        setSnackbarInfo,
        setSuccessMessage,
        setInfoMessage,
        setWarningMessage,
        setErrorMessage
      }}
    >
      {snackbarInfo.message && (
        <Box component="div" sx={styles.snackbar}>
          <InfoBar
            message={snackbarInfo.message}
            type={snackbarInfo.type}
            customAction={resetSnackbar}
            autoClose
          />
        </Box>
      )}
      {children}
    </SnackbarContext.Provider>
  )
}

export function useSnackbarContext(): SnackbarReturnedObject {
  return useContext(SnackbarContext)
}
